import { attr } from 'redux-orm'
import Base from './Base'

class BillingSupplierConfig extends Base {
  static get fields () {
    return {
      id: attr(),
      name: attr(),
      iban: attr(),
      enterpriseNumber: attr(),
      vatId: attr(),
      countryCode: attr(),
      addressLine: attr(),
      postalCode: attr(),
      city: attr(),
      email: attr(),
      phone: attr(),
      peppolId: attr(),
      peppyrusApiKey: attr(),
      invoiceConditions: attr(),
      invoiceMessage: attr()
    }
  }
}

BillingSupplierConfig.modelName = 'billingSupplierConfig'

export default BillingSupplierConfig
